// extracted by mini-css-extract-plugin
export default {"container":"DiagramChart_container__id1V9","svg":"DiagramChart_svg__a2ajV"};